var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMoneyBanknoteExchangeSecond(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 40,
    viewBox: "0 0 38 40",
    width: 38,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-5 -4)"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "m35 43-3-3 3-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m32 40h4c3.3137085 0 6-2.6862915 6-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13 5 3 3-3 3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16 8h-4c-3.3137085 0-6 2.6862915-6 6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m28 26v9.1083c0 1.5970418-1.2946582 2.8917-2.8917 2.8917h-16.2166c-1.59704181 0-2.8917-1.2946582-2.8917-2.8917v-10.2166c0-1.5970418 1.29465819-2.8917 2.8917-2.8917h15.1083c1.060866 0 2.0782816.4214274 2.8284271 1.1715729s1.1715729 1.7675611 1.1715729 2.8284271z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 30,
    r: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20 16v-3.1083c0-1.5970418 1.2946582-2.8917 2.8917-2.8917h15.1083c2.209139 0 4 1.790861 4 4v9.1083c0 .7669265-.3046604 1.5024417-.8469593 2.0447407-.542299.5422989-1.2778142.8469593-2.0447407.8469593h-5.1083"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m28.87868 15.87868c.7577307-.7585937 1.8627131-1.0551222 2.8984347-.777812 1.0357216.2773101 1.8447072 1.0862957 2.1220173 2.1220173.2773102 1.0357216-.0192183 2.140704-.777812 2.8984347"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m0 0h48v48h-48z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoneyBanknoteExchangeSecond);
export default __webpack_public_path__ + "static/media/money-banknote-exchange-second.b9a0a616356c2ad0c3045a315cbeab4a.svg";
export { ForwardRef as ReactComponent };